var React = require('react');

function Menu (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M19 13a1 1 0 0 1 1 1v.5a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V14a1 1 0 0 1 1-1h18Zm0-6.25a1 1 0 0 1 1 1v.5a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1v-.5a1 1 0 0 1 1-1h18ZM19 .5a1 1 0 0 1 1 1V2a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1v-.5a1 1 0 0 1 1-1h18Z","fill":"#000","fillRule":"evenodd"}));
}

Menu.defaultProps = {"viewBox":"0 0 20 16"};

module.exports = Menu;

Menu.default = Menu;
